var map = {
	"./menu-bg0.png": "59c2",
	"./menu-bg1.png": "310b",
	"./menu-bg2.png": "7ba2",
	"./menu-bg3.png": "a9d5",
	"./menu-bg4.png": "3f48",
	"./menu-bg5.png": "4dc7",
	"./menu-bg6.png": "b0e6",
	"./menu-bg7.png": "3a84",
	"./menu-bg8.png": "84b3",
	"./menu-bg9.png": "ffc8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0f8";